import { Flex } from "@givenwell/components";
import { MenuIcon } from "@givenwell/core-solid-icons";
import { keyframes, styled } from "@givenwell/stitches";
import { colors, easing } from "@givenwell/theme";
import { useMatches } from "@tanstack/react-router";
import { Dialog as BaseDialog } from "radix-ui";
import { useContext, useEffect, useState } from "react";
import { SidebarContext } from "./AppLayout";

export function SidebarDialogButton() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const match = useMatches({
    select(matches) {
      return matches?.findLast(() => true)?.routeId;
    },
  });
  const sidebar = useContext(SidebarContext);

  useEffect(() => {
    setDialogOpen(false);
  }, [match]);

  if (!sidebar) return null;

  return (
    <BaseDialog.Root open={dialogOpen} onOpenChange={setDialogOpen}>
      <DialogTrigger>
        <MenuIcon />
      </DialogTrigger>
      <BaseDialog.Portal>
        <DialogOverlay></DialogOverlay>
        <DialogContent>
          <Flex
            css={{
              flexDirection: "column",
              height: "100%",
              width: "100%",
            }}
          >
            {sidebar}
          </Flex>
        </DialogContent>
      </BaseDialog.Portal>
    </BaseDialog.Root>
  );
}

const overlayOpen = keyframes({
  from: {
    opacity: 0,
  },
  to: {
    opacity: 1,
  },
});
const overlayClose = keyframes({
  from: {
    opacity: 1,
  },
  to: {
    opacity: 0,
  },
});
const contentOpen = keyframes({
  from: {
    transform: "translateX(-100%)",
  },
  to: {
    transform: "translateX(0)",
  },
});
const contentClose = keyframes({
  from: {
    transform: "translateX(0)",
  },
  to: {
    transform: "translateX(-100%)",
  },
});

const DialogTrigger = styled(BaseDialog.Trigger, {
  size: 40,
  display: "flex",
  items: "center",
  justify: "center",
  ml: -10,
  "@md": { display: "none" },
});
const DialogOverlay = styled(BaseDialog.Overlay, {
  zIndex: 1000,
  position: "fixed",
  inset: 0,
  backgroundColor: colors.blue900 + "80",
  animation: `${overlayOpen()} 0.4s ${easing.standard}`,
  "&[data-state='closed']": {
    animation: `${overlayClose()} 0.3s ${easing.standard}`,
  },
});
const DialogContent = styled(BaseDialog.Content, {
  zIndex: 1000,
  background: colors.warmGreyHalf,
  position: "fixed",
  top: 0,
  bottom: 0,
  left: 0,
  width: "calc(100% - 72px)",
  maxW: 260,
  display: "flex",
  flexDirection: "column",
  overflowY: "auto",
  animation: `${contentOpen()} 0.4s ${easing.standard}`,
  "&[data-state='closed']": {
    animation: `${contentClose()} 0.3s ${easing.standard}`,
  },
});
